import React, { useEffect, useState } from 'react'
import OZDataGrid from '../../../components/admin/common/OZDataGrid/OZDataGrid';
import { Button, Stack, Tooltip } from '@mui/material';
import CustomSelect from '../Users/CustomSelect';
import { getPhoneNumberListWithName, getZohoMappings, saveZohoFwpNumberMapping } from '../../../services/api-service';
import { showErrorNotification, showSuccessNotification, showWarningNotification } from '../../../components/admin/common/NotiService';
import LoadingScreen from '../../../components/admin/common/OZLoadingScreen/OZLoadingScreen';

export default function PhoneNumberIntegration() {

  const [phoneNumberIntegrationList, setPhoneNumberIntegrationList] = useState([]);
  console.log(phoneNumberIntegrationList)
  const [fwpNumberZohoData, setfwpNumberZohoData] = useState();
  const [loading, setLoading] = useState();

  useEffect(() => {
    getZohoMappingsDetails();
  }, []);

  useEffect(() => {
    getPhoneNumberList();
  }, [fwpNumberZohoData])

  async function getZohoMappingsDetails() {
    // setAlreadyAssignedZohoUsers([]);
    setLoading(true);
    try {
      getZohoMappings()
        .then((resp) => {
          if (resp.Status === "Success") {
            let zohoData = resp.Data;
            let filteredZohoFwpNumbersMap = {};
            Object.entries(zohoData.zohoFWPMap).forEach(([key, value]) => {
              if (value !== "-1" && value !== -1) {
                filteredZohoFwpNumbersMap[key] = value;
              }
            });
            setfwpNumberZohoData({
              zohoFWPMap: filteredZohoFwpNumbersMap,
              zohoUsers: zohoData.zohoUsers
            });
            const zohoUsersValues = Object.values(zohoData.zohoUsers);
            const updatedOptions = ["DeSelect", ...zohoUsersValues];
            setOptions(updatedOptions);
          }
          else {
            showErrorNotification("Zoho Mappings Cannot Be Fetched .", resp.Message);
            setLoading(false);
          }
        })
        .catch((e) => {
          showErrorNotification("Error in fetching Zoho Mappings");
          // setLoading(false);
        });
    } catch (e) {
      showErrorNotification("Error in getting Zoho Mappings");
      setLoading(false);
    }
  };

  const [options, setOptions] = useState([])
  // const [alreadyAssignedZohoUsers, setAlreadyAssignedZohoUsers] = useState([])
  // console.log("🚀 ~ PhoneNumberIntegration ~ alreadyAssignedZohoUsers:", alreadyAssignedZohoUsers)

  const ZohoUserRenderer = (props) => {

    const [isEditMode, setEditMode] = useState(false);
    const [zohoUser, setZohoUser] = useState(props.data.zohoUser);

    const toggleEditMode = () => {
      setEditMode(!isEditMode);
      setZohoUser(props.data.zohoUser);
    };

    async function saveFwpNumbersZohoMapping() {
      const zohoUserVal = zohoUser;
      let result = null;
      for (const [key, value] of Object.entries(fwpNumberZohoData.zohoUsers)) {
        if (value === zohoUserVal) {
          result = key;
          break;
        }
      }
      if (zohoUserVal === "DeSelect") {
        result = "-1";
      }
      let data = {
        caFwp: (props?.data?.name && props?.data?.name?.length > 0) ? props?.data?.name?.toLowerCase() : "",
        zohoFwp: result
      }
      try {
        setLoading(true);
        saveZohoFwpNumberMapping(data)
          .then((resp) => {
            if (resp.Status === "Success") {
              if (zohoUserVal !== "DeSelect") {
                showSuccessNotification(`PhoneNumber ${props.data.phoneNumber} is Successfully Mapped with zohoUser ${zohoUser}`);
              }
              if (zohoUserVal === "DeSelect") {
                showSuccessNotification(`PhoneNumber ${props.data.phoneNumber} is Successfully UnMapped`);
              }
              setEditMode(false);
              getZohoMappingsDetails();
            }
            else {
              showErrorNotification("Error in save of Zoho FwpNumbers Mapping.", resp.Message);
              setLoading(false);
            }
          })
          .catch((e) => {
            showErrorNotification("Error in saving Zoho FwpNumbers Mapping");
            // setLoading(false);
          });
      } catch (e) {
        showErrorNotification("Error in Zoho FwpNumbers Mapping Saving");
        setLoading(false);
      }
    }

    return (
      <>
        {!isEditMode &&
          <div className='editButtonPosition'>
            <div> {zohoUser} </div>
            <Button variant="text" onClick={toggleEditMode} className="editButton"> Edit </Button>
          </div>
        }
        {isEditMode &&
          <>
            <Stack direction="row">
              <CustomSelect
                options={options}
                file="integration"
                placeholder={zohoUser}
                onChange={setZohoUser}
                // disabledOptions={alreadyAssignedZohoUsers}
                disableOptions={false}
              />
              <Stack direction="row" spacing="20px">
                <Button variant="text" onClick={toggleEditMode} className='discardButton'> Discard </Button>
                <Button variant="contained" className={(zohoUser !== "" && props.data.zohoUser !== zohoUser) ? (zohoUser === "DeSelect") ? (props.data.zohoUser !== "") ? 'saveButton' : 'notAllowSaveButton' : 'saveButton' : 'notAllowSaveButton'} onClick={(zohoUser !== "" && props.data.zohoUser !== zohoUser) ? (zohoUser === "DeSelect") ? (props.data.zohoUser !== "") ? saveFwpNumbersZohoMapping : null : saveFwpNumbersZohoMapping : null} size="small"> Save </Button>
              </Stack>
            </Stack>
          </>
        }
      </>
    );
  };

  const ColumnRenderer = (props) => {
    return (
      <Tooltip title={(props.value) ? props.value : ''}>
        <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", cursor: "pointer" }}>{props.value}</span>
      </Tooltip>
    );
  };

  const columnDefs = ([
    { field: 'name', headerName: 'Name', maxWidth: 160, cellRenderer: ColumnRenderer },
    { field: 'phoneNumber', headerName: 'Phone Number', maxWidth: 160, cellRenderer: ColumnRenderer },
    { field: 'zohoUser', headerName: 'Zoho User', cellRenderer: ZohoUserRenderer },
  ]);

  async function getPhoneNumberList() {
    try {
      console.log('fwpNumberZohoData', fwpNumberZohoData)
      getPhoneNumberListWithName()
        .then((resp) => {
          if (resp.Status === "Success") {
            let arrayOfObjects = resp.Data
            const updatedArrayOfObjects = arrayOfObjects.map(obj => {
              const modifiedPhoneName = obj.name.toLowerCase().replace(/[a-z]/g, char => char.toLowerCase());
              const zohoUser = fwpNumberZohoData.zohoFWPMap.hasOwnProperty(modifiedPhoneName) ?
                (fwpNumberZohoData.zohoUsers.hasOwnProperty(fwpNumberZohoData.zohoFWPMap[modifiedPhoneName]) ?
                  fwpNumberZohoData.zohoUsers[fwpNumberZohoData.zohoFWPMap[modifiedPhoneName]] : "") : "";
              console.log("🚀 ~ .then ~ modifiedPhoneName:", modifiedPhoneName, 'zohoUser', zohoUser)
              if (zohoUser !== "") {
                // setAlreadyAssignedZohoUsers(prevUsers => [...prevUsers, zohoUser])
              }
              return {
                ...obj,
                zohoUser: zohoUser
              };
            });
            setPhoneNumberIntegrationList(updatedArrayOfObjects);
            setLoading(false);
          }
          else {
            showWarningNotification(resp.Message);
            setLoading(false)
          }
        })
        .catch((e) => {
          setPhoneNumberIntegrationList([]);
          // setLoading(false)
        });
    } catch (e) {
      showErrorNotification("Error in PhoneNumber list");
      setLoading(false)
    }
  };

  return (
    <div className="ozAdminSubIntegrationContainer">
      {loading ?
        (
          <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} >
            <LoadingScreen />
          </div>
        ) :
        <OZDataGrid height="26.3rem" data={phoneNumberIntegrationList} columns={columnDefs} />
      }
    </div>
  );
};